<template>
  <section>
    <div>
      <h1 class="is-bolder font-lg">
        Olá{{ firstName ? `, ${firstName}` : '' }}!
      </h1>
      <small>
        Aqui está o essencial para o seu dia.
      </small>
    </div>
    <template v-if="hasForm">
      <component
        :is="componentForm.component"
      />
    </template>
  </section>
</template>

<script>
/* Store */
import { mapState } from 'vuex';

export default {
  name: 'NotifySection',
  data: () => ({
    formName: '',
  }),
  computed: {
    ...mapState({
      user: (state) => state.user.userInfo,
    }),
    firstName() {
      return this.user?.name?.split(' ')[0] || '';
    },
    hasForm() {
      return !!this.formName;
    },
    componentForm() {
      if (!this.hasForm) return null;

      return {
        component: () => import(`@/components/Alerts/${this.formName}.vue`),
      };
    },
    userCanAccessCreditCard() {
      const { routers } = JSON.parse(localStorage.getItem('menu'));
      return routers.some((route) => route['menu-item'] === 'Cartão de Crédito');
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/src/_textVariables.scss';

section {
  margin-top: 24px;

  display: grid;
  gap: 16px;

  h1 {
    font: {
      family: Inter;
      size: 24px;
      weight: 500;
    }
    text: {
      underline-position: from-font;
      decoration-skip-ink: none;
    }
    color: #4a4a4a;
  }
}
</style>
